<app-sprintpay-header
    [showFacilityInformation]="showFacilityInformation"
    [administrativeLoginURL]="administrativeLoginURL"
    [homeURL]="homeURL"
    [cartDisallowedRoutes]="cartDisallowedRoutes"
    [loginDisallowedRoutes]="loginDisallowedRoutes"
    [homeIconOutlined]="true"
    [showSettingsAtTheEnd]="true"
    [settingsButtonOutline]="true"
>
    <ng-content></ng-content>
    @if (displayDhlAviationLogo) {
        <div optional-logo-right-side>
            <img
                ngSrc="assets/dhl-aviation/img/dhl-aviation-logo.webp"
                width="264"
                height="102"
                style="width: 128px; height: auto"
                loading="lazy"
                alt="confirmation_check"
                class="ms-4"
            />
        </div>
    }
</app-sprintpay-header>
